import { DatePipe } from '@angular/common';
import { BrazilianCurrencyPipe } from '@brunsker/libs/core/utils/brazilian-currency/src/lib/pipes/brazilian-currency/brazilian-currency.pipe';
import { CURRENCY_PIPE, DATE_PIPE } from '../tokens/pipe.tokens';

export const DEFAULT_PIPES_PROVIDERS = [
  { provide: CURRENCY_PIPE, useClass: BrazilianCurrencyPipe },
  { provide: DATE_PIPE, useClass: DatePipe },
];
